import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ErrorMessage } from 'components/form/aksel';
import { FileDrop, FilePicked } from 'flyt';

function fileIsAccepted(file, accept) {
	if (!accept) {
		return true;
	}

	return accept
		.split(',')
		.map(rule => rule.trim().toLowerCase())
		.filter(Boolean)
		.some(rule => {
			if (rule.startsWith('.')) {
				return file.name.toLowerCase().endsWith(rule);
			}

			if (rule.endsWith('/*')) {
				return file.type.toLowerCase().startsWith(rule.slice(0, -1));
			}

			return file.type.toLowerCase() === rule;
		});
}

export default function FileField({
	name,
	label,
	defaultFileName = '',
	maxSize = null,
	accept = null,
	required = false,
	helperText,
	disabled = false,
}) {
	const { control } = useFormContext();
	const [pickedName, setPickedName] = useState(defaultFileName);
	const [pickedSize, setPickedSize] = useState(0);

	return (
		<Controller
			name={name}
			control={control}
			rules={{ required }}
			render={({ field: { onChange, value }, fieldState: { error } }) => {
				const showPicked = !!value || !!pickedName;

				return (
					<fieldset
						disabled={disabled}
						className="m-0 min-w-0 border-0 p-0"
					>
						{!disabled && (
							<FileDrop
								label={label}
								{...(helperText
									? { description: helperText }
									: {})}
								validate={file => {
									if (!fileIsAccepted(file, accept)) {
										return 'Filtypen er ikke tillatt.';
									}

									if (maxSize && file.size > maxSize) {
										const sizeMB = maxSize / 1000000;

										return `Filen et større en begrensingen på ${sizeMB.toFixed(0)} MB`;
									}

									return undefined;
								}}
								onFileAccepted={file => {
									setPickedName(file.name);
									setPickedSize(file.size);
									onChange(file);
								}}
							/>
						)}

						{showPicked && (
							<FilePicked
								name={value?.name ?? pickedName}
								size={value?.size ?? pickedSize}
								onRemove={() => {
									setPickedName('');
									setPickedSize(0);
									onChange(null);
								}}
							/>
						)}

						{error?.message && (
							<div className="mt-2">
								<ErrorMessage size="small" showIcon>
									{error.message}
								</ErrorMessage>
							</div>
						)}
					</fieldset>
				);
			}}
		/>
	);
}
